<script lang="js" setup>
import UiButton from "@/components/ui/UiButton.vue";
import Accordion from "@/components/homepage/Accordion.vue";
</script>

<template>
  <div
    id="faq"
    class="max-w-screen-xl 2xl:max-w-screen-2xl mx-auto min-h-screen container my-8 sm:my-10 lg:my-16 xl:my-20"
  >
    <div
      class="flex flex-col lg:flex-row gap-y-6 sm:gap-y-8 lg:gap-x-6 xl:gap-x-8 justify-between w-full"
    >
      <div class="flex-1">
        <div class="max-w-screen-sm">
          <h2
            class="uppercase font-semibold text-xl sm:text-2xl lg:text-3xl xl:text-4xl text-dark-text"
          >
            Questions resolved for enhanced collaboration
          </h2>
          <p class="text-dark-text sm:text-lg lg:text-xl mt-2 sm:mt-3 lg:mt-5">
            Got more questions? Don't hesitate to contact us
          </p>
          <UiButton class="mt-4 sm:mt-5 lg:mt-7">
            <span class="text-white text-base sm:text-lg">
              Engage With GPolls Now
            </span>
          </UiButton>
        </div>
      </div>
      <div class="flex-1 mb-10">
        <Accordion />
      </div>
    </div>
  </div>
</template>

<style scoped></style>
